import { render, staticRenderFns } from "./posted-opcr.vue?vue&type=template&id=dc2521c0&"
import script from "./posted-opcr.vue?vue&type=script&lang=js&"
export * from "./posted-opcr.vue?vue&type=script&lang=js&"
import style0 from "./posted-opcr.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports